import { Getters } from 'vuex-smart-module';
import CartDetailState from './state';

export default class CartDetailGetters extends Getters<CartDetailState> {
}
